export default __webpack_public_path__ + "static/media/gif1.356566d8.gif";